var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50402 16.2963H5.01341V7.9153L0 4.19043V14.8121C0 15.6269 0.678284 16.2963 1.50402 16.2963Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 16.2963H20.525C21.3507 16.2963 22.029 15.6269 22.029 14.8121V4.19043L17.0156 7.8862",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 1.48395V7.91517L22.029 4.2194V2.21147C22.029 0.378131 19.9057 -0.669488 18.4312 0.436333",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01172 7.9151V1.48389L11.0278 5.93627L17.0144 1.48389V7.9151L10.9983 12.3384",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.21144V4.19027L5.01341 7.88604V1.48392L3.59786 0.436303C2.12332 -0.640417 0 0.407203 0 2.21144Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16.2963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.c980ea0db3945211ac158ed2b522b8c2.svg";
export { ForwardRef as ReactComponent };